import { passwordValidation } from '@alluradirect/react';
import { Box, Typography } from '@mui/material';
import { LoadingButton } from 'components/core/LoadingButton/LoadingButton';

import Spacer from 'components/core/Spacer/Spacer';
import { FormikAppTextField } from 'components/formik/core/FormikAppTextField/FormikAppTextField';
import { Form, Formik } from 'formik';
import { useRestauthUserPasswordUpdateMutation } from 'hooks/api/user/mutations/useUserPasswordUpdateMutation';
import { useIsMutating } from 'react-query';
import { useUserIdSelector } from 'hooks/business/useUserIdSelector';
import { DividerTemp } from '../../components/styles';
import { useListPropertyCreateMutation } from '../hooks/useListPropertyCreate';
import { useListModalContext } from '../listModalContext';

export const ListPagePasswordForm = () => {
  const {
    listFormValues: { email, resort_id, listingUrl },
  } = useListModalContext();

  const userId = useUserIdSelector();

  const userPasswordMutate = useRestauthUserPasswordUpdateMutation();
  const handlePropertyCreation = useListPropertyCreateMutation();

  const onSubmit = (values: { PASSWORD: string }) => {
    userPasswordMutate.mutate(
      {
        password: values.PASSWORD,
      },
      {
        onSuccess: async () => {
          handlePropertyCreation.mutate({ id: userId, resort_id: resort_id, assisted_setup_url: listingUrl });
        },
      },
    );
  };
  const isMutating = useIsMutating() > 0;
  return (
    <Box>
      <Typography variant="h5" mb={2} textAlign="center">
        Account verified. Set your password
      </Typography>
      <DividerTemp my={3} />
      <Typography mb={2}>Thank you for verifying your account.</Typography>
      <Typography mb={2}>
        Your username will be <strong>{email}</strong>, please set the password you would like to use on this account.
      </Typography>
      <DividerTemp my={3} />
      <Formik
        initialValues={{ PASSWORD: '', PASSWORD_CONFIRM: '' }}
        onSubmit={onSubmit}
        validationSchema={passwordValidation}
      >
        <Form>
          <FormikAppTextField name="PASSWORD" isPasswordField label="New Password" />
          <Spacer />

          <FormikAppTextField name="PASSWORD_CONFIRM" isPasswordField label="New Password" />

          <Spacer />
          <LoadingButton isLoading={isMutating} isFormikButton isFullWidth buttonColor="secondary">
            Continue
          </LoadingButton>
        </Form>
      </Formik>
    </Box>
  );
};
